import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import { isClientFetchError } from '@atlassian/jira-fetch/src/utils/is-error.tsx';
import {
	fireOperationalAnalytics,
	fireTrackAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import sprintDeleteService from '@atlassian/jira-software-backlog/src/rest/sprint-delete/index.tsx';
import { REFRESH_SOURCE_FAILURE } from '../../model/constants';
import { refreshDataRequest } from '../../state/actions/app';
import {
	SPRINT_DELETE_REQUEST,
	type SprintDeleteRequestAction,
	sprintDeleteSuccess,
	sprintDeleteFailure,
} from '../../state/actions/sprints/delete';
import { getBaseUrl, getRapidViewId } from '../../state/selectors/app';
import type { MiddlewareAPI, ActionsObservable } from '../../state/types';

export const sprintDeleteEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(SPRINT_DELETE_REQUEST).mergeMap((action: SprintDeleteRequestAction) => {
		const {
			payload: { sprintId },
			meta: {
				optimistic: { id: optimisticId },
				analyticsEvent,
			},
		} = action;

		const state = store.getState();
		const baseUrl = getBaseUrl(state);
		const rapidViewId = getRapidViewId(state);

		return sprintDeleteService(baseUrl, sprintId, rapidViewId)
			.flatMap(() => {
				fireTrackAnalytics(analyticsEvent, 'sprint deleted');
				fireOperationalAnalytics(analyticsEvent, 'ui taskSuccess', {
					task: 'deleteSprint',
				});
				return Observable.of(sprintDeleteSuccess(sprintId, optimisticId));
			})
			.catch((error: Error) => {
				fireOperationalAnalytics(analyticsEvent, 'ui taskFail', {
					task: 'deleteSprint',
					isClientFetchError: isClientFetchError(error),
					errorMessage: error.message,
				});
				return Observable.from([
					sprintDeleteFailure(sprintId, optimisticId),
					refreshDataRequest(REFRESH_SOURCE_FAILURE),
				]);
			});
	});
